module.exports = {"id":"125167","name":"Ersan Gülüm","rating":"73","photo":"./data/images/photos/3/125167.png","club":{"name":"Adélaïde United","logo":"./data/images/clubs/AdelaideUnited.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ErsanGulum0.json
// module id = 1292
// module chunks = 0